import styled from 'styled-components'

interface ButtonWrapperProps {
  fixed: boolean
}

export const ButtonsWrapper = styled.div<ButtonWrapperProps>`
  &&& {
    display: inline-flex;
    ${fixed => fixed && 'position: fixed'};
    background: #fff;
    bottom: 0;
  }
`

export const OuterWrapper = styled.div`
  position: absolute;
  transform: translate(-14px, -50%);
  left: 100%;
  z-index: 100;
  width: 100%;
  padding: 0 16px;
  margin: 0;
  box-shadow: none;
  border: none;
  border-radius: 0;
`
export const InnerWrapper = styled.div`
  background: #fff;
  position: relative;
  border-radius: 4px;
  padding: 8px;
  border: 1px solid rgb(189, 203, 208);
  ::before {
    content: '';
    position: absolute;
    top: 50%;

    transform: rotate(45deg) translateY(-50%);
    width: 0;
    left: -12px;
    background: #fff;
    height: 0;
    width: 12px;
    height: 12px;
    border-left: 1px solid rgb(189, 203, 208);
    border-bottom: 1px solid rgb(189, 203, 208);
  }
`
